import { render, staticRenderFns } from "./PartnerBusinessContract.vue?vue&type=template&id=42c403ca&scoped=true&"
import script from "./PartnerBusinessContract.vue?vue&type=script&lang=js&"
export * from "./PartnerBusinessContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c403ca",
  null
  
)

export default component.exports